module.exports = __webpack_public_path__ + "static/media/inspiration.693aae0f.jpg";